import { AccountViewTypes } from '../AccountViewTypes';
const getAccountType = (account) => {
    if (!account) {
        return AccountViewTypes.NORMAL;
    }
    if ('creditLimit' in account.balance && account.balance.creditLimit) {
        return AccountViewTypes.CREDIT;
    }
    if (account.type === 'BSU') {
        return AccountViewTypes.BSU;
    }
    return AccountViewTypes.NORMAL;
};
export const getAccountViewTypeClassName = (type) => {
    switch (type) {
        case AccountViewTypes.BSU:
        case AccountViewTypes.CREDIT:
            return 'account-with-progress-bar';
        case AccountViewTypes.NORMAL:
        default:
            return '';
    }
};
export default getAccountType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0QWNjb3VudFR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9BY2NvdW50Vmlldy91dGlsL2dldEFjY291bnRUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBRXZELE1BQU0sY0FBYyxHQUFHLENBQUMsT0FBaUIsRUFBRSxFQUFFO0lBQ3pDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUNYLE9BQU8sZ0JBQWdCLENBQUMsTUFBTSxDQUFDO0lBQ25DLENBQUM7SUFFRCxJQUFJLGFBQWEsSUFBSSxPQUFPLENBQUMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsV0FBVyxFQUFFLENBQUM7UUFDbEUsT0FBTyxnQkFBZ0IsQ0FBQyxNQUFNLENBQUM7SUFDbkMsQ0FBQztJQUVELElBQUksT0FBTyxDQUFDLElBQUksS0FBSyxLQUFLLEVBQUUsQ0FBQztRQUN6QixPQUFPLGdCQUFnQixDQUFDLEdBQUcsQ0FBQztJQUNoQyxDQUFDO0lBQ0QsT0FBTyxnQkFBZ0IsQ0FBQyxNQUFNLENBQUM7QUFDbkMsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFzQixFQUFFLEVBQUU7SUFDbEUsUUFBUSxJQUFJLEVBQUUsQ0FBQztRQUNYLEtBQUssZ0JBQWdCLENBQUMsR0FBRyxDQUFDO1FBQzFCLEtBQUssZ0JBQWdCLENBQUMsTUFBTTtZQUN4QixPQUFPLDJCQUEyQixDQUFDO1FBQ3ZDLEtBQUssZ0JBQWdCLENBQUMsTUFBTSxDQUFDO1FBQzdCO1lBQ0ksT0FBTyxFQUFFLENBQUM7SUFDbEIsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=